// extracted by mini-css-extract-plugin
export default {"container":"styles_container__H1YxR","btnPrimary":"styles_btnPrimary__5567c"};